import { Fetch } from "../../shared/Fetch";
import { Submission, Requirement, SubmissionDayWise, RequirementDayWise, POs, ECIs, Margin } from "./DashboardModel";


// To fetch data from API's
const getData=async (link:string)=>{
    const response = await Fetch(`${link}`, "GET", null, null, null);
    const data = await response?.json();
    return data;
}

// Fetch all data.
export const getCompanyRequirments=async ()=>{

    const data=await getData("Dashboard/requirementCompany");
    
    let arr:Requirement[]=[];

    data.forEach((el:any)=>{
        let obj:Requirement={
            branchName:el.companyName,
            totalRequirement:el.totalRequirement,
            totalAllocation:el.totalAllocation,
            totalServices:el.servedCount,
            serving:el.subCount,
        };
        arr.push(obj);
    });

    return getCompanyRequirmentDayWise(arr);
}

export const getCompanySubmissions=async ()=>{

    const data=await getData("dashboard/submissionCompany");

    let arr:Submission[]=[];

    data.forEach((el:any)=>{
        let obj:Submission={
            branchName:el.companyName,
            totalSubmission:el.totalSubmission,
            totalSalesRejected:el.totalSalesRejected,
            totalPVRejected:el.totalPVRejected,
            totalEndClientSubmission:el.totalEndClientSubmission,
        };
        arr.push(obj);
    });

    return getCompanySubmissionDayWise(arr);
}

export const getCompanyECIs=async ()=>{

    const data=await getData("Dashboard/eciCompany");

    let arr:ECIs[]=[];

    data.forEach((el:any)=>{
        let obj:ECIs={
            branchName:el.companyName,
            totalECI:el.totalECI,
            totalBackoutECI:el.totalBackoutECI,
            totalConfirmedECI:el.totalConfirmedECI,
            totalRescheduledECI:el.totalRescheduledECI,
        };

        arr.push(obj);
    });

    return getCompanyECIDayWise(arr);
}

export const getCompanyPOs=async ()=>{

    const data=await getData("Dashboard/poCompany");

    let arr:POs[]=[];

    data.forEach((el:any)=>{
        let obj:POs={
            branchName:el.companyName,
            totalPO:el.totalPO,
            totalRunningPO:el.totalRunningPO,
            totalEndedPO:el.totalEndedPO,
            totalFizzledPO:el.totalFizzledPO,
        };

        arr.push(obj);
    });

    return getCompanyPODayWise(arr);
}

export const getCompanyMargins=async ()=>{

    const data=await getData("Dashboard/marginCompany");

    let arr:Margin[]=[];

    data.forEach((el:any)=>{
        let obj:Margin={
            branchName:el.companyName,
            totalMargin:el.totalMargin,
            totalRunningMargin:el.totalRunningMargin,
            totalEndedMargin:el.totalEndedMargin,
            totalFizzledMargin:el.totalFizzledMargin,
        };

        arr.push(obj);
    });

    return getCompanyMarginDayWise(arr);
}






// Fetch data according day wise.

export const getCompanyRequirmentDayWise=async (resp:Requirement[])=>{
    
    const data:RequirementDayWise=await getData("Dashboard/requirementCompanyDayWise");

    let day:Requirement={
        branchName:"Day Total",
        totalRequirement:data.dayTotalReq,
        totalAllocation:data.dayTotalAllocation,
        totalServices:data.dayTotalServed,
        serving:data.dayTotalSub,
    }

    let quarter:Requirement={
        branchName:"Quarter Total",
        totalRequirement:data.quarterTotalReq,
        totalAllocation:data.quarterTotalAllocation,
        totalServices:data.quarterTotalServed,
        serving:data.quarterTotalSub,
    }

    let month:Requirement={
        branchName:"Month Total",
        totalRequirement:data.monthTotalReq,
        totalAllocation:data.monthTotalAllocation,
        totalServices:data.monthTotalServed,
        serving:data.monthTotalSub,
    }

    resp=[...resp,day,month,quarter];

    return resp;

}

export const getCompanySubmissionDayWise=async(resp:Submission[])=>{

    const data:SubmissionDayWise=await getData("dashboard/submissionCompanyDayWise");
    
    let day:Submission={
        branchName:"Day Total",
        totalSubmission:data.dayTotalSubmission,
        totalSalesRejected:data.dayTotalSalesRejected,
        totalPVRejected:data.dayTotalPVRejected,
        totalEndClientSubmission:data.dayTotalEndClientSub,
    }

    let quarter:Submission={
        branchName:"Quarter Total",
        totalSubmission:data.quarterTotalSubmission,
        totalSalesRejected:data.quarterTotalSalesRejected,
        totalPVRejected:data.quarterTotalPVRejected,
        totalEndClientSubmission:data.quarterTotalEndClientSub,
    }

    let month:Submission={
        branchName:"Month Total",
        totalSubmission:data.monthTotalSubmission,
        totalSalesRejected:data.monthTotalSalesRejected,
        totalPVRejected:data.monthTotalPVRejected,
        totalEndClientSubmission:data.monthTotalEndClientSub,
    }

    resp=[...resp,day,month,quarter];

    return resp;

}

export const getCompanyECIDayWise=async(resp:ECIs[])=>{

    const data=await getData("Dashboard/eciCompanyDayWise");
    
    let day:ECIs={
        branchName:"Day Total",
        totalECI:data.dayTotalECI,
        totalBackoutECI:data.dayTotalBackoutECI,
        totalConfirmedECI:data.dayTotalConfirmedECI,
        totalRescheduledECI:data.dayTotalRescheduledECI,
    }

    let quarter:ECIs={
        branchName:"Quarter Total",
        totalECI:data.quarterTotalECI,
        totalBackoutECI:data.quarterTotalBackoutECI,
        totalConfirmedECI:data.quarterTotalConfirmedECI,
        totalRescheduledECI:data.quarterTotalRescheduledECI,
    }

    let month:ECIs={
        branchName:"Month Total",
        totalECI:data.monthTotalECI,
        totalBackoutECI:data.monthTotalBackoutECI,
        totalConfirmedECI:data.monthTotalConfirmedECI,
        totalRescheduledECI:data.monthTotalRescheduledECI,
    }

    resp=[...resp,day,month,quarter];

    return resp;

}

export const getCompanyPODayWise=async(resp:POs[])=>{

    const data=await getData("Dashboard/poCompanyDayWise");
    
    let day:POs={
        branchName:"Day Total",
        totalPO:data.dayTotalPO,
        totalRunningPO:data.dayTotalRunningPO,
        totalEndedPO:data.dayTotalEndedPO,
        totalFizzledPO:data.dayTotalFizzledPO,
    }

    let quarter:POs={
        branchName:"Quarter Total",
        totalPO:data.quarterTotalPO,
        totalRunningPO:data.quarterTotalRunningPO,
        totalEndedPO:data.quarterTotalEndedPO,
        totalFizzledPO:data.quarterTotalFizzledPO,
    }

    let month:POs={
        branchName:"Month Total",
        totalPO:data.monthTotalPO,
        totalRunningPO:data.monthTotalRunningPO,
        totalEndedPO:data.monthTotalEndedPO,
        totalFizzledPO:data.monthTotalFizzledPO,
    }

    resp=[...resp,day,month,quarter];

    return resp;

}

export const getCompanyMarginDayWise=async(resp:Margin[])=>{

    const data=await getData("Dashboard/marginCompanyDayWise");
    
    let day:Margin={
        branchName:"Day Total",
        totalMargin:data.dayTotalMargin,
        totalRunningMargin:data.dayTotalRunningMargin,
        totalEndedMargin:data.dayTotalEndedMargin,
        totalFizzledMargin:data.dayTotalFizzledMargin,
    }

    let quarter:Margin={
        branchName:"Quarter Total",
        totalMargin:data.quarterTotalMargin,
        totalRunningMargin:data.quarterTotalRunningMargin,
        totalEndedMargin:data.quarterTotalEndedMargin,
        totalFizzledMargin:data.quarterTotalFizzledMargin,
    }

    let month:Margin={
        branchName:"Month Total",
        totalMargin:data.monthTotalMargin,
        totalRunningMargin:data.monthTotalRunningMargin,
        totalEndedMargin:data.monthTotalEndedMargin,
        totalFizzledMargin:data.monthTotalFizzledMargin,
    }

    resp=[...resp,day,month,quarter];

    return resp;

}